var map = {
	"./1.png": 2799,
	"./10.png": 8028,
	"./2.png": 5386,
	"./3.png": 1927,
	"./4.png": 6434,
	"./5.png": 991,
	"./6.png": 3276,
	"./7.png": 4836,
	"./8.png": 9823,
	"./9.png": 6069,
	"./hero-bg.png": 3409,
	"./main-bg.jpg": 8473,
	"./main-bg.png": 8127,
	"./main-bg.svg": 1344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9758;